import { ca } from '@cian/analytics';

import { IAgentSchema, IOfferSchema, IUserSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

import { getAction, getCustomUrl, getPage, getPartner, getUser } from '../../utils/tracking';
import { getProducts } from '../../utils/tracking/get_products';

export function trackOpenPhonesClick(
  offer: IOfferSchema,
  agent: IAgentSchema | null,
  user: IUserSchema | null,
  abGroup: number,
  kpId: number | null,
  bot?: boolean,
) {
  const { workTimeInfo } = offer;

  const products = getProducts(agent, offer, kpId);

  ca('eventSite', {
    action: getAction(`Open_card_more_block${bot ? '_bot' : ''}`, workTimeInfo),
    category: 'Phones',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
    page: getPage(agent, offer),
    partner: getPartner(user, offer),
    products: [
      {
        ...products,
        variant: products.variant ? products.variant.split('/') : [],
      },
    ],
    user: getUser(user, abGroup),
  });
}
